import { useMutation } from "@tanstack/react-query";

import { errorToast } from "@/shared/ui";
import { submitDietitianForm } from "../api";

export const useSubmitDietitianForm = () => {
  return useMutation({
    mutationFn: submitDietitianForm,
    onError: errorToast,
  });
};
